// Shared validation patterns used across the application

// Password must contain:
// - At least one lowercase letter
// - At least one uppercase letter
// - At least one number
// - At least one special character
// - At least 3 letters total (uppercase or lowercase)
// - Minimum 10 characters total
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])(?=(?:.*?[a-zA-Z]){3})[A-Za-z\d!@#$%^&*()-_=+{}[\]]{10,}$/;

